module.exports = __webpack_public_path__ + "img/Eduracle_Logo.89d15010.png";